module.exports = __webpack_public_path__ + "img/press-2.0b660b7d.jpg";